// extracted by mini-css-extract-plugin
module.exports = {"issuerProfileMenu":"issuer-profile-content_issuerProfileMenu__d1iE6"};